import { render } from "./welcome-to-anthem.vue?vue&type=template&id=6f472081"
import script from "./welcome-to-anthem.vue?vue&type=script&lang=js"
export * from "./welcome-to-anthem.vue?vue&type=script&lang=js"

import "./welcome-to-anthem.vue?vue&type=style&index=0&id=6f472081&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__